export default {
  title: {
    en: 'Switch to English',
    sk: 'Prepnúť do Slovenčiny',
  },
};



// WEBPACK FOOTER //
// ./src/modules/LanguageSelector/messages.js